var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouseExchange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "42px",
    viewBox: "0 0 40 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4.1-About",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.1.1-Project-page-/-About",
    transform: "translate(-1172.000000, -830.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(1087.000000, 792.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "house-exchange-percent",
    transform: "translate(82.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "13 5 16 8 13 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,8 L11.99924,8 C8.68595581,8 6,10.6859558 6,13.99924 L6,14",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "35 45 32 42 35 39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,42 L36.00076,42 C39.3140442,42 42,39.3140442 42,36.00076 L42,36",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,20 L22,14 C22,10.6862915 24.6862915,8 28,8 L36,8 C39.3137085,8 42,10.6862915 42,14 L42,22 C42,25.3137085 39.3137085,28 36,28 L30,28",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.00076,
    y1: 21,
    x2: 35.00076,
    y2: 15,
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5,21.30074 C35.4995918,21.4110517 35.4099437,21.5002037 35.2996314,21.4999997 C35.1893191,21.4997956 35.1000014,21.4103125 35.1000014,21.3 C35.1000014,21.1896875 35.1893191,21.1002044 35.2996314,21.1000003 C35.4099437,21.0997963 35.4995918,21.1889483 35.5,21.29926 L35.5,21.30074",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5,14.69926 C28.5004082,14.5889483 28.5900563,14.4997963 28.7003686,14.5000003 C28.8106809,14.5002044 28.8999986,14.5896875 28.8999986,14.7 C28.8999986,14.8103125 28.8106809,14.8997956 28.7003686,14.8999997 C28.5900563,14.9002037 28.5004082,14.8110517 28.5,14.70074 L28.5,14.69926",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8807,30.245 L6.8807,40 C6.8807,41.1045695 7.7761305,42 8.8807,42 L21,42 C22.1045695,42 23,41.1045695 23,40 L23,30.4006",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.85036,32 L16.15824,24.4869 C15.407163,23.8376789 14.293537,23.8376789 13.54246,24.4869 L4.85036,32",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseExchange);
export default __webpack_public_path__ + "static/media/house-exchange.0e260e002ec4a2b2082cd30e60707e75.svg";
export { ForwardRef as ReactComponent };